import React from 'react'
import { Menu, Dropdown } from 'antd'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import styles from './style.module.scss'

@injectIntl
class ProjectManagement extends React.Component {
  render() {
    const {
      intl: { formatMessage },
    } = this.props
    const menu = (
      <Menu selectable={false}>
        <Menu.ItemGroup title={formatMessage({ id: 'projects.active' })}>
          <Menu.Item>
            <Link to="/">
              <FormattedMessage id="projects.controlMultiloop" />
            </Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="/">
              <FormattedMessage id="projects.biolerRoom" />
            </Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="/">
              <FormattedMessage id="projects.mechatronicLab" />
            </Link>
          </Menu.Item>
        </Menu.ItemGroup>
        <Menu.ItemGroup title={formatMessage({ id: 'projects.inactive' })}>
          <Menu.Item>
            <Link to="/">
              <FormattedMessage id="projects.plcExamples" />
            </Link>
          </Menu.Item>
        </Menu.ItemGroup>
        <Menu.Divider />
        <Menu.Item>
          <Link to="/">
            <i className={`${styles.menuIcon} icmn-cog`} />
            <FormattedMessage id="projects.settings" />
          </Link>
        </Menu.Item>
      </Menu>
    )
    return (
      <Dropdown overlay={menu} trigger={['click']} placement="bottomLeft">
        <div className={styles.dropdown}>
          <i className={`${styles.icon} icmn-database`} />
          <span className="d-none d-xl-inline">
            <strong>
              <FormattedMessage id="topBar.projectManagement" />
            </strong>
          </span>
        </div>
      </Dropdown>
    )
  }
}

export default ProjectManagement
